import React from "react";
import RoomItem from "@/components/RoomItem";
import { RoomsType } from "@/types";
import PlaceHolderRoom from "./PlaceHolderRoom";
import { motion } from "framer-motion";
import { tabVariantsAnimation } from "@/theme/theme";

// Define the Rooms interface
interface RoomsProps {
    rooms: RoomsType[];
    loading: boolean; // Add loading prop
}

const Rooms: React.FC<RoomsProps> = ({ rooms, loading }) => {
    // loading = true;
    return (
        <motion.section
            variants={tabVariantsAnimation}
            animate='animate'
            initial='initial'
            className="flex flex-col"
        >
            {loading
                ? // Display exactly 4 placeholders when loading
                Array.from({ length: 4 }).map((_, index) => (
                    <div
                        key={index}
                        className="col-span-4 mb-5 md:col-span-2 lg:col-span-1"
                    >
                        <PlaceHolderRoom />
                    </div>
                ))
                : // Display room items when not loading
                rooms.map((room, index) => (
                    <div
                        key={index}
                        className="col-span-4 md:col-span-2 lg:col-span-1"
                    >
                        <RoomItem room={room} loading={loading} />
                    </div>
                ))}
        </motion.section>
    );
};

export default Rooms;
